export default function getRoutePermissions( route ) {
	let routePermissions;

	if ( route.meta ) {
		const authType = typeof route.meta.auth;

		if ( authType === "boolean" || authType === "string" || Array.isArray( route.meta.auth ) ) {
			routePermissions = route.meta.auth;
		} else if ( authType === "object" && route.meta.auth.roles ) {
			routePermissions = route.meta.auth.roles;
		}
	}

	return routePermissions;
}
